import { isDefinedString, isPositiveNumber } from "et3-type-guards";
import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { apiSendOneOOneMultipleMsgs } from "../../../api/khattbat-api/send-one-o-one-multiple-msgs";
import getCorePopUpStore from "../../core/core-popup-store";
import getKhattabat101CStore from "../101c-stores";
import getKhattabat101MatchStore from "../101m-stores";
import getKhattabatSelectsStore from "../selects-store";
import { TalkhattabatConversationType } from "../../../Types";
import getKhattabatStore from "..";
import getKhattabatSharedMessagingStore from "./conversation-messaging-store";

class KhattabatBulkMessagingStore {
  isOpenedBulkMessagesBox = observable.box<boolean>(false);
  isSendingMessages = observable.box<boolean>(false);
  fieldsInput = observable.map<number, string>([]);

  setIsSendingMessages = (state: boolean) => {
    runInAction(() => {
      this.isSendingMessages.set(state);
    });
  };

  setIsOpenedBulkMessagesBox = (state: boolean) => {
    runInAction(() => {
      this.isOpenedBulkMessagesBox.set(state);
    });
  };

  setFieldInput = ({ index, text }: { text: string; index: number }) => {
    runInAction(() => {
      this.fieldsInput.set(index, text);
    });
  };

  initializeInputFields = () => {
    for (let index = 0; index < 10; index++) {
      this.setFieldInput({ index, text: "" });
    }
  };

  toggleIsOpenedBox = () => {
    const currentState = this.isOpenedBulkMessagesBox.get();
    this.setIsOpenedBulkMessagesBox(!currentState);
  };

  shouldSendMessages = computed(() => {
    const hasDefinedField = Array.from(this.fieldsInput.values()).some(
      (text) => {
        return isDefinedString(text);
      }
    );
    return hasDefinedField && !this.isSendingMessages.get();
  });
  getConversationMessages = () => {
    let conversationMessages: string[] = [];
    Array.from(this.fieldsInput.values()).forEach((text) => {
      if (isDefinedString(text)) {
        conversationMessages.push(text);
      }
    });
    return conversationMessages;
  };

  sendAllMessages = async (conversationType: TalkhattabatConversationType) => {
    const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
    const currentMarkeduserId = getKhattabatSelectsStore().getMarkedUserIds();
    const noChosenUsers = !isPositiveNumber(currentMarkeduserId.length);
    if (noChosenUsers) {
      return getCorePopUpStore().showAlertMessage("PLEASE_AT_LEAST_ONE_USER");
    }
    const isMatchConversation = conversationType === "101M";

    const conversationParticipants = currentMarkeduserId.map((userID) => {
      const userUUID = isMatchConversation
        ? getKhattabat101MatchStore(userID).matchUUID.get()
        : getKhattabat101CStore(userID).userUUID.get();
      return {
        alkhattabaUUID,
        userUUID,
        userID
      };
    });

    const conversationMessages = this.getConversationMessages();
    this.setIsSendingMessages(true);
    const { status, code } = await apiSendOneOOneMultipleMsgs({
      conversationParticipants,
      conversationMessages,
      conversationType
    });
    this.setIsSendingMessages(false);
    if (status === "OK") {
      conversationParticipants.forEach(({ userID }) => {
        const conversationID = isMatchConversation
          ? getKhattabat101MatchStore(userID).conversationID.get()
          : getKhattabat101CStore(userID).oneOOneCId.get();

        conversationMessages.forEach((message) => {
          getKhattabatSharedMessagingStore(conversationID).appendSentMessage({
            message,
            messageType: "text"
          });
        });
      });
      this.initializeInputFields();
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

export const getKhattabatBulkMessagingStore = memoize(
  () => new KhattabatBulkMessagingStore(),
  () => 1
);

export default getKhattabatBulkMessagingStore;
